import React from 'react';
import AppSpinner from '~/components/Loading/AppSpinner';

type SpinnerProps = {
  isCentered?: boolean;
};

/**
 * Backwards-compatible wrapper around `AppSpinner` (orbit BrailleLoader,
 * the inline data-loading look). Prefer importing `AppSpinner` directly in new code.
 */
export default function Spinner({ isCentered }: SpinnerProps) {
  return <AppSpinner isCentered={isCentered} />;
}
